import axios from "../../utils/axiosConfig.js";
import { server } from "../../server/server";

// Create Sale
export const createSale = (newSale) => async (dispatch, getState) => {
    try {
        dispatch({ type: "createSaleRequest" });

        const { data } = await axios.post(`${server}/sale/create-sale`, newSale, { withCredentials: true });

        dispatch({
            type: "createSaleSuccess",
            payload: data.sale,
        });
        const { currentUser } = getState().user;
        dispatch(getSalesByStore(currentUser.store._id)); // Refresh sales after creation
        dispatch(getLatestSale(currentUser._id)); // Update latest sale
    } catch (error) {
        dispatch({
            type: "createSaleFail",
            payload: error.response?.data?.message || error.message,
        });
    }
};

// Add Sale
export const addSale = (newSale) => async (dispatch) => {
    try {
        dispatch({ type: "addSaleRequest" });

        const { data } = await axios.post(`${server}/sale/add`, newSale, { withCredentials: true });

        dispatch({
            type: "addSaleSuccess",
            payload: data.sale,
        });
    } catch (error) {
        dispatch({
            type: "addSaleFail",
            payload: error.response?.data?.message || error.message,
        });
    }
};

// Reprint receipt for an existing sale
export const reprintReceipt = (saleId) => async (dispatch) => {
    try {
        dispatch({ type: "reprintReceiptRequest" });

        const { data } = await axios.get(`${server}/sale/reprint-receipt/${saleId}`, {
            withCredentials: true,
        });

        dispatch({
            type: "reprintReceiptSuccess",
            payload: data.message,
        });
    } catch (error) {
        dispatch({
            type: "reprintReceiptFail",
            payload: error.response?.data?.message || error.message,
        });
    }
};

// Get sales by store
export const getSalesByStore = (storeId) => async (dispatch) => {
    try {
        if (!storeId) {
            dispatch({
                type: "getSalesByStoreFail",
                payload: "Store ID is required",
            });
            return;
        }

        dispatch({ type: "getSalesByStoreRequest" });

        const { data } = await axios.get(`${server}/sale/get-sales-by-store/${storeId}`,
            { withCredentials: true }
        );

        dispatch({
            type: "getSalesByStoreSuccess",
            payload: data.sales
        });

    } catch (error) {
        dispatch({
            type: "getSalesByStoreFail",
            payload: error.response?.data?.message || error.message,
        });
    }
};

// Delete Sale
export const deleteSale = (id, store) => async (dispatch) => {
    try {
        dispatch({ type: "deleteSaleRequest" });

        const { data } = await axios.delete(`${server}/sale/delete/${id}`, {
            withCredentials: true,
        });

        dispatch({
            type: "deleteSaleSuccess",
            payload: data.message,
        });
        dispatch(getSalesByStore(store)); // Refresh sales after deletion

    } catch (error) {
        dispatch({
            type: "deleteSaleFailed",
            payload: error.response?.data?.message || error.message,
        });
    }
};

// Legacy: Fetch All Sales (DEPRECATED - use getSalesByStore instead)
export const getAllSales = () => async (dispatch) => {
    try {
        dispatch({ type: "getAllSalesRequest" });

        const { data } = await axios.get(`${server}/sale/get-all-sales`, { withCredentials: true });

        dispatch({
            type: "getAllSalesSuccess",
            payload: data.sales,
        });
    } catch (error) {
        const errorMessage = error.response?.data?.message || error.message;

        dispatch({
            type: "getAllSalesFailed",
            payload: errorMessage,
        });
    }
};



// Fetch Single Sale by ID
export const getSaleById = (id) => async (dispatch) => {
    try {
        dispatch({ type: "getSaleByIdRequest" });

        const { data } = await axios.get(`${server}/sale/sale/${id}`, { withCredentials: true });

        dispatch({
            type: "getSaleByIdSuccess",
            payload: data.sale,
        });
    } catch (error) {
        dispatch({
            type: "getSaleByIdFailed",
            payload: error.response?.data?.message || error.message,
        });
    }
};

// Get Sales by Staff
export const getSalesByStaff = (staffId) => async (dispatch) => {
    try {
        dispatch({ type: "getSalesByStaffRequest" });

        const { data } = await axios.get(`${server}/sale/get-sales-by-staff/${staffId}`, { withCredentials: true });

        dispatch({
            type: "getSalesByStaffSuccess",
            payload: data.sales,
        });
    } catch (error) {
        dispatch({
            type: "getSalesByStaffFail",
            payload: error.response?.data?.message || error.message,
        });
    }
};

// Get Sales by Cashier
export const getSalesByCashier = (cashierId) => async (dispatch) => {
    try {
        dispatch({ type: "getSalesByCashierRequest" });

        const { data } = await axios.get(`${server}/sale/get-sales-by-cashier/${cashierId}`, { withCredentials: true });

        dispatch({
            type: "getSalesByCashierSuccess",
            payload: data.cashierSales,
        });
    } catch (error) {
        dispatch({
            type: "getSalesByCashierFail",
            payload: error.response?.data?.message || error.message,
        });
    }
};

// Get Latest Sale
export const getLatestSale = (cashierId) => async (dispatch) => {
    try {
        dispatch({ type: "getLatestSaleRequest" });

        const { data } = await axios.get(`${server}/sale/get-latest-sale/${cashierId}`, { withCredentials: true });
        dispatch({
            type: "getLatestSaleSuccess",
            payload: data.latestSale,
        });
    } catch (error) {
        dispatch({
            type: "getLatestSaleFail",
            payload: error.response?.data?.message || error.message,
        });
    }
};

export const editSale = (id, updatedData) => async (dispatch) => {
    try {
        dispatch({ type: "editSaleRequest" });

        const { data } = await axios.put(`${server}/sale/sale/${id}`, updatedData, { withCredentials: true });

        dispatch({
            type: "editSaleSuccess",
            payload: data.sale,
        });

    } catch (error) {
        dispatch({
            type: "editSaleFailed",
            payload: error.response?.data?.message || error.message,
        });
    }
};

// Get Sales by Customer
export const getCustomerSales = (customerId) => async (dispatch) => {
    try {
        dispatch({ type: "getCustomerSalesRequest" });

        const { data } = await axios.get(`${server}/sale/get-customer-sales/${customerId}`, { withCredentials: true });

        dispatch({
            type: "getCustomerSalesSuccess",
            payload: data.customerSales,
        });
    } catch (error) {
        dispatch({
            type: "getCustomerSalesFailed",
            payload: error.response?.data?.message || error.message,
        });
    }
};